import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';
import { buildDevPermissionBypassHeaders } from '@/permissions/devBypass';

type ScopedRequestOptions = RequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
      headers: {
        ...buildDevPermissionBypassHeaders(),
        ...(options?.headers || {}),
        ...(BizAppConfig.appSsoClientId
          ? { 'x-app-id': BizAppConfig.appSsoClientId }
          : {}),
      },
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
